
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15.295","height":"15.292","viewBox":"0 0 15.295 15.292"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 147414","d":"M7.653 3.725a3.914 3.914 0 00-3.924 3.921 3.914 3.914 0 003.924 3.921 3.914 3.914 0 003.917-3.921 3.914 3.914 0 00-3.917-3.921zm0 6.469a2.554 2.554 0 01-2.552-2.548 2.551 2.551 0 012.552-2.549 2.551 2.551 0 012.545 2.549 2.554 2.554 0 01-2.545 2.549zm5-6.63a.915.915 0 00-.914-.914.915.915 0 00-.914.914.912.912 0 00.914.914.912.912 0 00.906-.913zm2.6.928a4.525 4.525 0 00-1.235-3.2 4.555 4.555 0 00-3.2-1.235c-1.278-.075-5.065-.075-6.325 0a4.549 4.549 0 00-3.2 1.232 4.54 4.54 0 00-1.235 3.2c-.072 1.263-.072 5.047 0 6.309a4.525 4.525 0 001.235 3.2 4.561 4.561 0 003.2 1.235c1.263.072 5.047.072 6.309 0a4.526 4.526 0 003.2-1.235 4.555 4.555 0 001.235-3.2c.076-1.262.076-5.041.005-6.305zm-1.642 7.665a2.58 2.58 0 01-1.458 1.45 16.853 16.853 0 01-4.5.307 16.984 16.984 0 01-4.511-.307 2.58 2.58 0 01-1.454-1.45 16.852 16.852 0 01-.307-4.507 16.983 16.983 0 01.307-4.507 2.58 2.58 0 011.454-1.454 16.853 16.853 0 014.511-.311 16.984 16.984 0 014.508.307 2.58 2.58 0 011.454 1.454 16.852 16.852 0 01.307 4.507 16.842 16.842 0 01-.311 4.511z","fill":"#fff"}})])
          )
        }
      }
    